import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL, SUPPRESS_ALL_GROWL } from "utils/constants";
import { Account } from "rhombus-react";

export const USER_ACTIONS = {
	LOAD_USER_AJAX:"LOAD_USER_AJAX",
	LOAD_USER_SUCCESS:"LOAD_USER_SUCCESS",
	LOAD_USER_ERROR:"LOAD_USER_ERROR",

	LOAD_USER_FROM_AJAX:"LOAD_USER_FROM_AJAX",
	LOAD_USER_FROM_SUCCESS:"LOAD_USER_FROM_SUCCESS",
	LOAD_USER_FROM_ERROR:"LOAD_USER_FROM_ERROR",

	LOAD_ZENDESK_TOKEN_AJAX:"LOAD_ZENDESK_TOKEN_AJAX",
	LOAD_ZENDESK_TOKEN_SUCCESS:"LOAD_ZENDESK_TOKEN_SUCCESS",
	LOAD_ZENDESK_TOKEN_ERROR:"LOAD_ZENDESK_TOKEN_ERROR",

	RELOAD_USER_AJAX:"RELOAD_USER_AJAX",
	SET_USER_INFO:"SET_USER_INFO",

	LOAD_SENATORS_AJAX: "LOAD_SENATORS_AJAX",
	LOAD_SENATORS_SUCCESS: "LOAD_SENATORS_SUCCESS",
	LOAD_SENATORS_ERROR: "LOAD_SENATORS_ERROR",
};

const userAJAX = {
	url: "user",
	gateway: "crm",
	version: 1,
	success: USER_ACTIONS.LOAD_USER_SUCCESS,
	error: USER_ACTIONS.LOAD_USER_ERROR,
};

export function loadUser(suppressHighGround = false){
	return (dispatch, getState) => {
		// dispatch({ type:"NCM", AJAX:{ url:"user", gateway:"cm", success:"a", error:"b" } });

		return dispatch({
			type:USER_ACTIONS.LOAD_USER_AJAX,
			AJAX: userAJAX,
			meta:{
				...SUPPRESS_SUCCESS_GROWL,
				suppressHighGround,
			},
		});
	};
}

export function reloadUser(){
	return (dispatch, getState) => {
		return dispatch({
			type:USER_ACTIONS.RELOAD_USER_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: userAJAX,
		});
	};
}

export function loadUserFrom(gateway = false, version = 1){
	return (dispatch) => {
		let AJAX = {
			url:"user",
			gateway,
			version,
			success: USER_ACTIONS.LOAD_USER_FROM_SUCCESS,
			error: USER_ACTIONS.LOAD_USER_FROM_ERROR,
		};

		return dispatch({
			type:USER_ACTIONS.LOAD_USER_FROM_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX,
		});
	};
}

export function loadZendeskToken(){
	return (dispatch) => {
		return dispatch({
			type:USER_ACTIONS.LOAD_ZENDESK_TOKEN_AJAX,
			meta:SUPPRESS_ALL_GROWL,
			AJAX:{
				url:"ui/generate-web-widget-jwt",
				gateway:"zen",
				success: USER_ACTIONS.LOAD_ZENDESK_TOKEN_SUCCESS,
				error: USER_ACTIONS.LOAD_ZENDESK_TOKEN_ERROR,
			},
		});
	};
}

export function loadSenators(){
	return (dispatch) => {
		return dispatch({
			type: USER_ACTIONS.LOAD_SENATORS_AJAX,
			AJAX: {
				url: "ui/application-cards",
				gateway: "hub",
				success: USER_ACTIONS.LOAD_SENATORS_SUCCESS,
				error: USER_ACTIONS.LOAD_SENATORS_ERROR,
			},
			meta:{ suppressGrowl:true },
		});
	};
}

const IT = {
		id:              -1,
		name:            "",
		isInternal:      false,
		isLoaded:        false,
		isReloading:     false,
		hasErrorLoading: false,
		hasAccess:       false,
		departmentId:    -1,
		zendeskJWT:      null,
		account:Account.INITIAL_ACCOUNT_STATE,
	}
	, handlers = {
		[USER_ACTIONS.LOAD_USER_AJAX]:    isLoadingUser,
		[USER_ACTIONS.LOAD_USER_SUCCESS]: initUser,
		[USER_ACTIONS.LOAD_USER_ERROR]:   initErrorUser,
		[USER_ACTIONS.RELOAD_USER_AJAX]:  isReloadingUser,
		[USER_ACTIONS.SET_USER_INFO]:     initUserInfo,
		[USER_ACTIONS.LOAD_ZENDESK_TOKEN_SUCCESS]:initZendesk,
		...Account.ACCOUNT_HANDLERS,
	};


function isReloadingUser(state, action){
	return { ...state, isReloading:true, isLoaded:false };
}

function isLoadingUser(state, action){
	return { ...state, isLoaded:false };
}

function initUser(state, action){
	let { data } = action.payload;
	let { name } = data;

	return{
		...state,
		...data,
		name,
		isInternal:(data.businessEntityId === 1),
		hasErrorLoading:false,
		isLoaded:true,
		isReloading:false,
	};
}

function initErrorUser(state, action){
	return { ...state, isLoaded:true, isReloading:false, hasErrorLoading:true };
}

function initUserInfo(state, action) {
	const { browser, locale } = action.payload;
	let userLocale = 'en-us';

	if (!!locale) {
		userLocale = locale.toLowerCase();
	}

	return { ...state, browser, locale: userLocale };
}


function initZendesk(state, action){
	let { jwt } = action.payload.data;

	return {
		...state,
		zendeskJWT:jwt,
	};
}

export const REDUCERS = {
	isLoadingUser,
	isReloadingUser,
	initErrorUser,
	initUser,
	initUserInfo,
	initZendesk,
};

export default createReducer(IT, handlers);
